const colByScreenWidth = {
  1280: 4,
  1920: 8,
}

const gridContainerId = 'grid-container'

const gridLayoutConstants = { colByScreenWidth, gridContainerId }

export default gridLayoutConstants
